import React from "react";
export const Cross: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fillRule="evenodd">
		<path
			d="M22.8776695,0.733311749 L25.4403745,3.26668825 L15.7411708,13.0773117 L25.5838752,22.7784382 L23.0542168,25.3448134 L13.2081708,15.6393117 L3.44064351,25.5211068 L0.877938495,22.9877302 L10.6421708,13.1093117 L0.735170764,3.34508218 L3.26482924,0.778707018 L13.1751708,10.5473117 L22.8776695,0.733311749 Z"
			fillRule="nonzero"
		></path>
	</g>
);
